import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  ButtonConfirm,
  ButtonCancel,
  ContainerButtons,
  Modal,
  Text,
} from './styles';

const ModalUnmerge = (props) => {
  const {
    onClose,
    onClearCategories,
    selectedCategories,
    deleteMergedCategory,
  } = props;

  const handleDeleteMergedCategory = (selectedCategoriesIds) => {
    deleteMergedCategory({
      variables: {
        attributes: {
          mergedCategoriesIds: selectedCategoriesIds,
        },
      },
    });
  };

  const handleUnmergeCategory = () => {
    const categoriesIds = _.map(selectedCategories, (category) => category.id);
    handleDeleteMergedCategory(categoriesIds);
    onClose();
    onClearCategories();
  };

  return (
    <Modal
      open
      onClose={onClose}
      closeOnEscape
      closeOnDimmerClick
    >
      <Text>Do you want to unmerge the category?</Text>

      <ContainerButtons>
        <ButtonCancel
          onClick={onClose}
        >
          No
        </ButtonCancel>
        <ButtonConfirm
          onClick={handleUnmergeCategory}
        >
          Yes
        </ButtonConfirm>
      </ContainerButtons>
    </Modal>
  );
};

ModalUnmerge.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  onClearCategories: PropTypes.func.isRequired,
  deleteMergedCategory: PropTypes.func.isRequired,
};

export default ModalUnmerge;
